import { Badge } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import styles from "../TakenActions.module.scss"

import type { TakenActionStatus } from "../TakenActions.types"

const STATUS_COLOR: Record<TakenActionStatus, string> = {
  mitigated: "var(--golden-purple-5-color)",
  pending: "var(--daybreak-blue-6-color)"
}

export const ActionStatusBadge = ({
  status
}: {
  status: TakenActionStatus
}) => {
  const { t } = useTranslation()

  return (
    <Badge
      color={STATUS_COLOR[status]}
      text={
        <span className={styles.statusText}>
          {t(`triage.remediation.actions.status.${status}`)}
        </span>
      }
    />
  )
}
